import { useGetFAQs } from 'api/faqs';
import useUser from 'hooks/useUser';
import filterFAQs from 'modules/overview/utils/filterFAQs';
import React, { useCallback, useMemo } from 'react';
import { BlockerFunction, useBlocker } from 'react-router';
import { SearchResultDivider, SearchResultsWrapper } from './FAQSearchResults.styles';
import { SearchResultPreview } from './SearchResultPreview';

export function FAQSearchResults({
  searchQuery,
  onHideSearchResults,
  isVisible,
}: {
  searchQuery: string;
  onHideSearchResults: () => void;
  isVisible: boolean;
}) {
  const { data: faqData } = useGetFAQs();
  const { userResult } = useUser();

  const searchResultFAQs = useMemo(
    () => filterFAQs(faqData || null, userResult?.user, searchQuery),
    [faqData, userResult?.user, searchQuery],
  );

  const shouldBlock: BlockerFunction = useCallback(
    ({ historyAction }) => {
      if (isVisible && historyAction === 'POP') {
        onHideSearchResults();
        return true;
      }
      return false;
    },
    [isVisible, onHideSearchResults],
  );

  useBlocker(shouldBlock);

  return (
    <SearchResultsWrapper>
      {searchResultFAQs?.map((faq, idx) => (
        <>
          <SearchResultPreview key={faq.id} faq={faq} />
          {idx < searchResultFAQs.length - 1 && <SearchResultDivider />}
        </>
      ))}
    </SearchResultsWrapper>
  );
}

export default FAQSearchResults;
